<header>
	<div class="row">
		<img src={{logo}} alt="Generalitat de Catalunya" />
		<!-- <div class="language-bar">
			<button (click)="changeLanguage('ca_ES')">ca</button>
			<button (click)="changeLanguage('es_ES')">es</button>
			<button (click)="changeLanguage('en_GB')">en</button>
			<button (click)="changeLanguage('oc_ES')">en</button>
		</div> -->
	</div>
	<div class="row titol">
		<h1 >{{'globals.title_header' | translate}}</h1>	
		<nav class="menu-principal">
			<ul>
				<li *ngIf="simulacio!=null" [routerLink]="['home']" [routerLinkActive]="'active'" disabled>{{'globals.inici' | translate}}</li>
				<li *ngIf="simulacio!=null" [routerLink]="pestanyaActiva" [routerLinkActive]="'active'">
					{{'globals.simulacio' | translate}} <i class="fas fa-times" (click)="confirm.open('tancar-simulacio')"></i>
				</li>
			</ul>
		</nav>
	</div>
	<app-confirm id="tancar-simulacio" text="{{'globals.tancar_simulacio' | translate}}" (accept)="tancarSimulacio()"></app-confirm>
</header>